import { Image, Text, View } from '@react-pdf/renderer'
import { headerStyles } from './headerStyles';
import { useDates } from '../../../../hooks/useDates';

const { header } = headerStyles();

export const Header = ({ data, showTranslatedText }: any) => {

    const { TimeConverter , removeGMTOffset } = useDates();

    let salesPreorderDate = null;
    let regex = /\([^)]*\)/g;


    const isEmptyOrWhitespace = (str: string) => {
        return str.trim().length === 0;
    }

    if (!isEmptyOrWhitespace(data.dataSalesPreorders?.sales_preorder_date)) {
        salesPreorderDate = TimeConverter(data.dataSalesPreorders?.sales_preorder_date)?.toString();
        if (salesPreorderDate) {
            salesPreorderDate = salesPreorderDate.replace(regex, '').trim();
            salesPreorderDate= removeGMTOffset(salesPreorderDate?.toString())

        }
    }

    return (
        <View fixed style={header.container} >
            <Image src={data.dataSalesPreorders.logoImage ? data.dataSalesPreorders.logoImage : ' '}
                style={header.image} />
            <View style={header.dataHeaderContainer}  >
                <View style={header.dataIssuingCompanyContainer}  >
                    <Text style={header.textHeaderStylesBold}>{data.dataSalesPreorders?.company_business_name || " "}</Text>
                    <Text style={header.textHeaderStyles}>{data.dataSalesPreorders?.company_street || " "}</Text>
                    <Text style={header.textHeaderStyles}>{data.dataSalesPreorders?.company_city_name || " "}, {data.dataSalesPreorders?.company_state_name || " "}</Text>
                    <Text style={header.textHeaderStyles}>{showTranslatedText("reports.salesPreorderPdf.header.taxId")}: {data.dataSalesPreorders?.company_rfc || " "}</Text>
                </View>
                <View style={header.dataIssuingCompanyContainer2} >
                    <Text style={header.textHeaderStylesBold}>{showTranslatedText("reports.salesPreorderPdf.header.salesPreorder")}</Text>
                    <View style={header.dataIssuingCompanyContainer3} >
                        <View style={{ flexDirection: 'row', borderWidth: 1 }}>
                            <Text style={header.textHeaderStylesBold2}>{showTranslatedText("reports.salesPreorderPdf.header.folioNumber")}</Text>
                            <Text style={{
                                width: '60%',
                                fontSize: 7,
                                paddingVertical: 3,
                                fontWeight: 400,
                                paddingLeft: 2
                            }}>{data.dataSalesPreorders?.sales_preorder_name || " "}</Text>
                        </View>
                        <View style={{
                            flexDirection: 'row', borderBottomWidth: 1, borderLeftWidth: 1, borderRightWidth: 1
                        }}>
                            <Text style={header.textHeaderStylesBold2}>{showTranslatedText("reports.salesPreorderPdf.header.date")}</Text>
                            <Text style={{
                                width: '60%',
                                fontSize: 7,
                                paddingVertical: 3,
                                fontWeight: 400,
                                paddingLeft: 2
                            }}>{!salesPreorderDate ? " " : salesPreorderDate}</Text>
                        </View>
                    </View>
                </View>
            </View>
        </View>
    )
}
